<template>
  <div>
    <Head title="Welcome" />
    <v-carousel
      dark
      :height="$vuetify.breakpoint.mobile ? 400 : 600"
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item v-for="(item, i) in banners" :key="i">
        <v-img
          :src="item.image_url"
          class="fill-height"
          content-class="bg-black-10"
        >
          <v-container :class="sectionClass" class="fill-height white--text">
            <v-row no-gutters>
              <v-col cols="12" md="6">
                <v-row class="flex-column">
                  <v-col cols="12">
                    <div
                      class="font-weight-black text-elevation-1"
                      :class="[
                        $vuetify.breakpoint.mobile ? 'text-h4' : 'text-h2',
                      ]"
                      :style="{ color: item.title_color }"
                      v-html="item.title"
                    ></div>
                  </v-col>
                  <v-col cols="12">
                    <div
                      class="font-weight-bold text-elevation-1"
                      :class="[
                        $vuetify.breakpoint.mobile ? 'text-body-1' : 'text-h5',
                      ]"
                      :style="{ color: item.subtitle_color }"
                      v-html="item.subtitle"
                    ></div>
                  </v-col>
                  <v-col v-if="item.is_action" cols="12">
                    <v-btn
                      rounded
                      dark
                      :outlined="item.action_style === 'outlined'"
                      :color="item.action_color"
                      :href="item.action_url"
                      :large="!$vuetify.breakpoint.mobile"
                      :target="item.action_target"
                    >
                      {{ item.action_text }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-img>
      </v-carousel-item>
    </v-carousel>
    <v-container :class="sectionClass" class="text-center">
      <p
        class="font-weight-bold primary--text"
        :class="{
          'text-h4': !$vuetify.breakpoint.mobile,
          'text-h5': $vuetify.breakpoint.mobile,
        }"
      >
        XuYuan Class <br />Tempat Belajar Bahasa Mandarin Terbaik
      </p>
      <p>
        XuYuan Class adalah tempat kursus Bahasa Mandarin secara online dengan
        tim guru yang profesional dan metode pengajaran yang interaktif.
      </p>
      <v-btn
        depressed
        color="primary"
        :href="registerUrl"
        target="_blank"
        :large="!$vuetify.breakpoint.mobile"
      >
        Mulai Belajar
      </v-btn>
    </v-container>
    <v-container id="programs" :class="sectionClass">
      <p
        class="font-weight-bold primary--text text-center"
        :class="{
          'text-h4': !$vuetify.breakpoint.mobile,
          'text-h5': $vuetify.breakpoint.mobile,
        }"
      >
        Program Kursus XuYuan
      </p>
      <v-row justify="center" align="center" class="mt-4">
        <v-col v-for="(item, i) in programs" :key="i" cols="12" md="4">
          <v-hover>
            <template #default="{ hover }">
              <v-card :elevation="hover ? 16 : 2">
                <v-img
                  :height="$vuetify.breakpoint.xlOnly ? 300 : 250"
                  :src="item.image_url"
                ></v-img>
                <v-card-title class="card-header primary--text">
                  {{ item.title }}
                </v-card-title>
                <v-card-text class="card-content">
                  {{ item.content }}
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="primary"
                    text
                    :href="item.action_url"
                    target="_blank"
                  >
                    Lihat Detail
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
    <v-container :class="sectionClass">
      <p
        class="font-weight-bold primary--text text-center"
        :class="{
          'text-h4': !$vuetify.breakpoint.mobile,
          'text-h5': $vuetify.breakpoint.mobile,
        }"
      >
        Mengapa Memilih XuYuan?
      </p>
      <v-row justify="center" align="baseline" class="mt-4">
        <v-col v-for="(item, i) in benefits" :key="i" cols="12" md="3">
          <v-card flat>
            <v-img
              :src="item.image_url"
              class="mx-auto"
              max-width="100"
              height="84"
              contain
            />
            <v-card-title class="card-header justify-center text-center">
              {{ item.title }}
            </v-card-title>
            <v-card-text class="text-center">
              {{ item.content }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container :class="sectionClass">
      <p
        class="font-weight-bold primary--text text-center"
        :class="{
          'text-h4': !$vuetify.breakpoint.mobile,
          'text-h5': $vuetify.breakpoint.mobile,
        }"
      >
        Guru Profesional Kami
      </p>
      <v-row justify="center" align="center" class="mt4">
        <v-col v-for="(item, i) in teachers" :key="i" cols="12" md="4" xl="3">
          <v-card flat outlined>
            <v-card-title class="justify-center">
              <!-- <v-img
                :src="item.image_url"
                width="128"
                max-width="128"
                height="172"
              ></v-img> -->
              <v-avatar color="primary" size="128">
                <img :src="item.image_url" :alt="item.name" />
              </v-avatar>
            </v-card-title>
            <v-card-title
              class="card-header justify-center"
              style="min-height: 90px"
            >
              <div class="text-center">
                <div class="text-h6 primary--text font-weight-bold">
                  {{ item.name }} Laoshi
                </div>
                <div class="text-subtitle-2">{{ item.short_desc }}</div>
              </div>
            </v-card-title>
            <v-card-text class="card-content">
              {{ item.description }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container :class="sectionClass">
      <p
        class="font-weight-bold primary--text text-center"
        :class="{
          'text-h4': !$vuetify.breakpoint.mobile,
          'text-h5': $vuetify.breakpoint.mobile,
        }"
      >
        Apa Kata Mereka?
      </p>
      <v-row justify="center" align="center" class="mt4">
        <v-col
          v-for="(item, i) in testimonies"
          :key="i"
          cols="12"
          md="4"
          xl="3"
        >
          <v-card flat outlined>
            <v-card-title class="card-header align-start">
              <v-avatar color="primary" size="72" class="mr-4">
                <img :src="item.image_url" :alt="item.name" />
              </v-avatar>
              <div>
                <div class="text-h6 primary--text font-weight-bold">
                  {{ item.name }}
                </div>
                <div class="text-subtitle-1">
                  {{ item.job }}, {{ item.age }} tahun
                </div>
              </div>
            </v-card-title>
            <v-card-text class="card-content-long font-italic">
              {{ item.content }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue'
import LayoutHome from '@layouts/Home.vue'
import constant from '@/constant'
export default {
  name: 'Home',
  components: {
    Head,
  },
  layout: LayoutHome,
  data() {
    return {
      banners: [
        {
          title: 'Mau Lancar Berbahasa Mandarin?',
          title_color: null,
          subtitle:
            'Belajar Mandarin secara online dimanapun dan kapanpun dengan mudah!<br /> Bersama guru lokal maupun guru native asli dari China',
          subtitle_color: '#FFFFFF',
          image_url: require('~/images/banner-01.jpg'),
          is_action: true,
          action_text: 'Mulai Sekarang',
          action_url: constant.waRegisterUrl,
          action_color: '#00bfa5',
          action_style: null,
          action_target: '_blank',
        },
        {
          title: 'Tempat Belajar Bahasa Mandarin Terbaik Bagi Si Kecil',
          title_color: '#F8C302',
          subtitle:
            'Metode pembelajaran interaktif yang seru dan tidak membuat anak bosan seperti <strong><i>Games</i></strong>, <strong><i>Story-telling</i></strong>, <strong><i>Sing</i></strong>, <strong><i>Dance</i></strong> dan <strong><i>Cooking</i></strong>',
          subtitle_color: '#FFFFFF',
          image_url: require('~/images/banner-02.jpg'),
          is_action: false,
          action_text: null,
          action_url: null,
          action_style: null,
          action_target: null,
        },
        {
          title: 'Belajar Bahasa Mandarin <br/>Anti Gagal',
          title_color: null,
          subtitle:
            'Metode pembelajaran yang disesuaikan dengan usia dan kebutuhan masing-masing murid, sehingga proses belajar menjadi lebih efektif dan efisien',
          subtitle_color: null,
          image_url: require('~/images/banner-03.jpg'),
          is_action: true,
          action_text: 'Lihat Selengkapnya',
          action_url: '#programs',
          action_color: '#FFFFFF',
          action_style: 'outlined',
          action_target: null,
        },
        {
          title: 'Promo Khusus <br/>Untuk Bulan Ini',
          title_color: null,
          subtitle: 'Dapatkan Harga Special Khusus Untuk Anda',
          subtitle_color: null,
          image_url: require('~/images/banner-04.jpg'),
          is_action: true,
          action_text: 'Hubungi Kami',
          action_url: constant.waPromoUrl,
          action_color: '#00bfa5',
          action_style: null,
          action_target: '_blank',
        },
      ],
      programs: [
        {
          title: 'Mandarin untuk Anak',
          content:
            'Kelas Mandarin untuk Anak usia 3 – 16 tahun. Persiapkan buah hati Anda dengan kemampuan Bahasa yang matang.',
          image_url: require('~/images/mandarin-untuk-anak.jpg'),
          action_url: `${constant.waContactUrl}${qs.stringify(
            {
              text: 'Halo XuYuan Class, saya mau info tentang program kursus Mandarin untuk Anak',
            },
            { addQueryPrefix: true }
          )}`,
        },
        {
          title: 'Mandarin untuk Dewasa',
          content:
            'Kelas Mandarin untuk usia 18 tahun ke atas. Terbagi ke dalam 3 jenis kelas, yaitu: Basic, Intermediate, dan Advanced.',
          image_url: require('~/images/mandarin-untuk-dewasa.jpg'),
          action_url: `${constant.waContactUrl}${qs.stringify(
            {
              text: 'Halo XuYuan Class, saya mau info tentang program kursus Mandarin untuk Dewasa',
            },
            { addQueryPrefix: true }
          )}`,
        },
        {
          title: 'Persiapan Ujian HSK',
          content:
            'Mempelajari kosa kata dilengkapi dengan berbagai latihan untuk memaksimalkan pemahaman murid pada persiapan ujian HSK 1 hingga HSK 6.',
          image_url: require('~/images/mandarin-hsk-exam.jpg'),
          action_url: `${constant.waContactUrl}${qs.stringify(
            {
              text: 'Halo XuYuan Class, saya mau info tentang program kursus Mandarin untuk Persiapan Ujian HSK',
            },
            { addQueryPrefix: true }
          )}`,
        },
        {
          title: 'Mandarin Conversation',
          content:
            'Mengutamakan kemampuan berbicara dalam berbahasa Mandarin agar dapat berkomunikasi dengan baik.',
          image_url: require('~/images/mandarin-conversation.jpg'),
          action_url: `${constant.waContactUrl}${qs.stringify(
            {
              text: 'Halo XuYuan Class, saya mau info tentang program kursus Mandarin Conversation',
            },
            { addQueryPrefix: true }
          )}`,
        },
        {
          title: 'Company Training',
          content:
            'Mempersiapkan kemampuan untuk mendukung keterampilan penggunaan bahasa Mandarin dalam pekerjaan pada perusahaan.',
          image_url: require('~/images/mandarin-company-training.jpg'),
          action_url: `${constant.waContactUrl}${qs.stringify(
            {
              text: 'Halo XuYuan Class, saya mau info tentang program kursus Mandarin Company Training',
            },
            { addQueryPrefix: true }
          )}`,
        },
        {
          title: 'Mandarin untuk Bisnis / Profesional',
          content:
            'Miliki kesempatan karir dan bisnis yang lebih baik dengan meningkatkan kemampuan Bahasa Mandarin',
          image_url: require('~/images/mandarin-untuk-bisnis.jpg'),
          action_url: `${constant.waContactUrl}${qs.stringify(
            {
              text: 'Halo XuYuan Class, saya mau info tentang program kursus Mandarin untuk Bisnis / Profesional',
            },
            { addQueryPrefix: true }
          )}`,
        },
      ],
      benefits: [
        {
          title: 'Simpel dan Fleksibel',
          content:
            'Temui pengajar dan pantau progres belajar, di manapun dan kapanpun dengan satu aplikasi saja.',
          image_url:
            'https://mainsite.static.cakap.com/wp-content/uploads/2020/03/reason-multiscreen.svg',
        },
        {
          title: 'Belajar Melalui Beragam Cara',
          content:
            'Belajar privat atau berkelompok, melalui panggilan video atau chat, kamu bebas pilih.',
          image_url:
            'https://mainsite.static.cakap.com/wp-content/uploads/2020/03/reason-services.svg',
        },
        {
          title: 'Tenaga Pengajar Profesional',
          content:
            'Pengajar tersertifikasi dan berpengalaman siap membantumu keluar dari hambatan berbahasa Mandarin.',
          image_url:
            'https://mainsite.static.cakap.com/wp-content/uploads/2020/03/reason-pro-teacher.svg',
        },
        {
          title: 'Kredibilitas Terjamin',
          content:
            'Bekerja sama dengan berbagai lembaga pendidikan bahasa terpercaya.',
          image_url:
            'https://mainsite.static.cakap.com/wp-content/uploads/2020/03/reason-credible.svg',
        },
      ],
      teachers: [
        {
          name: 'Anna',
          short_desc: null,
          description: 'Pengalaman 3 tahun mengajar anak-anak',
          image_url: require('~/images/teacher/anna.jpg'),
        },
        {
          name: 'Chen Hui',
          short_desc: 'Quan Zhou Normal University',
          description: 'Pengalaman 2 tahun mengajar anak-anak',
          image_url: require('~/images/teacher/chen-hui.jpg'),
        },
        {
          name: 'Deng Qing',
          short_desc: 'Xi Hua Normal University',
          description: 'Berpengalaman mengajar bahasa Mandarin selama 4 tahun',
          image_url: require('~/images/teacher/deng-qing.jpg'),
        },
        {
          name: 'Li Ji Yang',
          short_desc: null,
          description:
            'Pengalaman lebih dari 20 tahun mengajar pada sekolah Indonesia',
          image_url: require('~/images/teacher/li-ji-yang.jpg'),
        },
        {
          name: 'Ye Lai Qing',
          short_desc: 'Chong Qing Normal University',
          description:
            'Pengalaman lebih dari 15 tahun mengajar pada beberapa sekolah di Indonesia',
          image_url: require('~/images/teacher/ye-lai-qing.jpg'),
        },
        {
          name: 'Zhou Huan',
          short_desc: 'Si Chuan University',
          description:
            'Memiliki pengalaman 20 tahun mengajar pada sekolah di Indonesia',
          image_url: require('~/images/teacher/zhou-huan.jpg'),
        },
        {
          name: 'Angelin Lai',
          short_desc: 'Universitas Widya Kartika',
          description:
            'Pemenang lomba Han Yu Qiao se Jawa Timur. Pengalaman mengajar 4 tahun',
          image_url: require('~/images/teacher/angelin.jpg'),
        },
        {
          name: 'Bernardino Fu',
          short_desc:
            'Wenzao Ursuline Language University, Shih Chien University Kaohsiung Campus',
          description: 'Pengalaman 5 tahun mengajar bahasa Mandarin',
          image_url: require('~/images/teacher/bernard-fu.jpg'),
        },
        {
          name: 'Levina Chen',
          short_desc: 'Universitas Kristen Petra  & Yang Zhou University',
          description: 'Pengalaman 2 tahun mengajar bahasa Mandarin',
          image_url: require('~/images/teacher/levina.jpg'),
        },
        {
          name: 'Shinta Zheng',
          short_desc: 'South China Normal Univesity',
          description: 'Pengalaman mengajar 10 tahun',
          image_url: require('~/images/teacher/shinta.jpg'),
        },
      ],
      testimonies: [
        {
          name: 'Aisyah',
          content:
            'Laoshinya udah sangat bagus kak, anak-anak sekarang jadi hepi banget dengan laoshi yang ini. Yaya Mandarinnya udah improved',
          age: 5,
          job: 'Kindergarten',
          image_url: require('~/images/ic-girl-01.jpg'),
        },
        {
          name: 'Aiden',
          content:
            'Are their teachers are will qualified and very very patent with kids! Thank you Anna Laoshi',
          age: 3,
          job: 'Pre-School',
          image_url: require('~/images/ic-boy-01.jpg'),
        },
        {
          name: 'Athena',
          content:
            'So far,  anak saya sangat nyaman dengan Fenny laoshi. Laoshinya sangat sabar dan memiliki metode pengajaran yang menyenangkan buat anak saya',
          age: 4,
          job: 'Kindergarten',
          image_url: require('~/images/ic-girl-01.jpg'),
        },
        {
          name: 'Felicia',
          content:
            'Sometimes we are serious, sometimes notttt, but there is always something to learn. One f the best decisions we made this pandemic is to enrol ourselves and all our 3 kids in XuYuan Class',
          age: 22,
          job: 'Adult Private Class',
          image_url: require('~/images/ic-girl-02.jpg'),
        },
        {
          name: 'Kenzo',
          content:
            'Laoshi sudah mengajar dengan sangat jelas dan sabar, akhirnya Kenzo juga fun dengan les Mandarinnya. Terima kasih banyak XuYuan Class',
          age: 6,
          job: 'Primary',
          image_url: require('~/images/ic-boy-01.jpg'),
        },
        {
          name: 'Alaric',
          content:
            'Dari sekolah masi TK minim bangettttt Mandarin koko,sejak els online di XuYuan Class, tiba-tiba jadi banyak banget bahasa Mandarin yang koko tau, Omaiggat mama bener-bener takjub dan terharuu',
          age: 5,
          job: 'Kindergarten',
          image_url: require('~/images/ic-boy-01.jpg'),
        },
        {
          name: 'Fransiska',
          content:
            'Saya tau XuYuan Class dari mamagrams. Ingin belajar Mandarin agar dapat mengerti pelajaran dan homework anak di sekolah. Belajar Mandarin online dengan Xu Yuan sangat praktis khususnya untuk mama-mama yang harus menghemat waktu sambal mengurus keluarga dan rumah. Shinta Laoshi sangat sabar dalam mengajar dan mengarahkan untuk membangun potensi dan perkembangan belajar murid juga para admin yang selalu siap menjawab pertanyaan dengan efisien.',
          age: 22,
          job: 'Adult Class',
          image_url: require('~/images/ic-girl-02.jpg'),
        },
      ],
    }
  },
  computed: {
    registerUrl() {
      return constant.waRegisterUrl
    },
  },
}
</script>
